import { toBig } from '@cast/utils';

import { MoneyPerPeriod } from 'components/money';

import { CostPeriod } from '../_types/cost';

import type { TypographyProps } from '@cast/design-system';

type Props = {
  price?: number;
  costPeriod?: CostPeriod;
  emptyValuePlaceholder?: React.ReactNode;
  primaryTextProps?: TypographyProps;
  suffixTextProps?: TypographyProps;
  showUnroundedPriceTooltip?: boolean;
  testId?: string;
};

export const NodeCost = ({
  price,
  costPeriod = 'hourly',
  emptyValuePlaceholder = '-',
  primaryTextProps,
  suffixTextProps,
  showUnroundedPriceTooltip = true,
  testId,
}: Props) => {
  if (!price) {
    return emptyValuePlaceholder;
  }

  return (
    <MoneyPerPeriod
      moneyProps={{
        amount: toBig(price).toNumber(),
        precision: 3,
        fixed: 3,
      }}
      primaryTextProps={primaryTextProps}
      suffixTextProps={suffixTextProps}
      suffix={costPeriod[0]}
      compact={showUnroundedPriceTooltip}
      testId={testId}
    />
  );
};
